import { render, staticRenderFns } from "./ByelawsKeyValueForm.vue?vue&type=template&id=25df8651&"
import script from "./ByelawsKeyValueForm.vue?vue&type=script&lang=js&"
export * from "./ByelawsKeyValueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports